import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  Dropdown,
  Form,
  FormGroup,
  FormField,
  Checkbox
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Calendar
} from 'react-big-calendar'

const CardPatientAppointmentUX = (props: any) => {
    return(
      <div
        id="CardPatientAppointmentUX-div-0"
        style={{ width: "100%", height: "95dvh", display: "flex" }}>
        <div
          className="patient-appointment-panel"
          id="CardPatientAppointmentUX-div-14"
          style={{ padding: "5px", flex: 1, backgroundColor: "#d6ecf3" }}>
          
          <div
            className="patient-appointment-menus"
            id="CardPatientAppointmentUX-div-56"
            style={{marginBottom:"5px", borderBottom: "solid #cccccc 1px"}}>
            
            <Button
              color={props.mode === "search" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-57"
              onClick={() => props.setMode("search")}
              size="tiny"
              style={{paddingRight: "1.25em", paddingLeft: "1.25rem"}}>
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
            <Button
              color={props.mode === "reschedule" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-58"
              onClick={() => props.setMode("reschedule")}
              size="tiny"
              style={props.disabledPostponeBtn ? {display: "none"} : {display: "inline-block",paddingRight: "1.25em", paddingLeft: "1.25rem"}}>
              {props.languageUX === "en" ? "Postpone (Clinic)" : "เลื่อน (คลินิก)"}
            </Button>
            <Button
              color={props.mode === "reconfirm" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-62"
              onClick={() => props.setMode("reconfirm")}
              size="tiny"
              style={props.disabledPostponeBtn ? {display: "none"} : {display: "inline-block",paddingRight: "1.25em", paddingLeft: "1.25rem"}}>
              {props.languageUX === "en" ? "Postpone (patient)" : "เลื่อน (ผู้ป่วย)"}
            </Button>
            <Button
              color={props.mode === "waitingList" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-59"
              onClick={() => props.setMode("waitingList")}
              size="tiny"
              style={props.disabledWaitingListBtn ? {display: "none"} : {display: "inline-block",paddingRight: "1.25em", paddingLeft: "1.25rem"}}>
              {props.languageUX === "en" ? "Waiting List" : "Waiting List"}
            </Button>
          </div>
          <div
            id="CardPatientAppointmentUX-div-55"
            style={{display: props.mode === "search" ? "block" : "none"}}>
            
            <div
              id="CardPatientAppointmentUX-div-79"
              style={{marginLeft: "5px" }}>
              {props.languageUX === "en" ? "HN patient" : "HN ผู้ป่วย"}
            </div>
            <div
              id="CardPatientAppointmentUX-div-3"
              style={{ display: "flex", gap: "5px"}}>
              
              <div
                id="CardPatientAppointmentUX-div-78"
                style={{width: "100%"}}>
                {props.patientSearch}
              </div>
              <Button
                color="brown"
                id="CardPatientAppointmentUX-Button-1"
                onClick={props.onPatientSearch}
                size="small">
                {props.languageUX === "en" ? "Search" : "ค้นหา"}
              </Button>
              <Button
                color="red"
                id="CardPatientAppointmentUX-Button-46"
                onClick={props.clearAppointment}
                size="small">
                {props.languageUX === "en" ? "clear" : "เคลียร์"}
              </Button>
            </div>
            <div
              id="CardPatientAppointmentUX-div-19">
              
              <div
                id="CardPatientAppointmentUX-div-11"
                style={{ fontWeight: "bold", fontSize: "1.2rem", margin: "5px" }}>
                {props.languageUX === "en" ? "Patients from search terms" : "คนไข้จากคำค้นหา"}
              </div>
              <div
                id="CardPatientAppointmentUX-div-4">
                
                <Table
                  className="--rt-tbody-overflow-y-hidden"
                  data={props.patientList}
                  getTrProps={props.patientRowProps}
                  headers="HN,ชื่อ-สกุล,Citizen ID/Passport No.,เบอร์โทรติดต่อ"
                  id="CardPatientAppointmentUX-Table-5"
                  keys="hn,full_name, citizen_passport, present_mobile_no"
                  minRows="4"
                  showPagination={false}
                  style={{height: "175px", marginBottom: "10px" }}
                  widths="^80,^80,^120,^90">
                </Table>
              </div>
            </div>
            <div
              id="CardPatientAppointmentUX-div-20"
              style={{ display: props.hideAppointmentTable ? "none" : "block" }}>
              
              <div
                id="CardPatientAppointmentUX-div-12"
                style={{ fontWeight: "bold", fontSize: "1.2rem", margin: "12px 0px 5px 0px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                
                <div
                  id="CardPatientAppointmentUX-div-15">
                  {props.languageUX === "en" ? "Previous appointment" : "นัดหมายก่อนหน้า"}
                </div>
                <div
                  id="CardPatientAppointmentUX-div-81">
                  
                  <Button
                    color="green"
                    disabled={props.disabledCreatePatientAppointment}
                    id="CardPatientAppointmentUX-Button-82"
                    onClick={props.createPatientAppointment}
                    size="small"
                    style={{display : props.PopupElement ? "none": ""}}>
                    {props.languageUX === "en" ? "Add appointment" : "เพิ่มนัดหมาย"}
                  </Button>
                  <div
                    id="CardPatientAppointmentUX-div-83">
                    {props.PopupElement}
                  </div>
                </div>
              </div>
              <div
                id="CardPatientAppointmentUX-div-64"
                style={{display:"flex", justifyContent: "space-between"}}>
                
                <div
                  id="CardPatientAppointmentUX-div-65"
                  style={{fontWeight: "bold", flex: "0 0 48%"}}>
                  {props.languageUX === "en" ? "physician" : "แพทย์"}
                  <div
                    id="CardPatientAppointmentUX-div-69">
                    {props.doctorSearch}
                  </div>
                </div>
                <div
                  id="CardPatientAppointmentUX-div-66"
                  style={{fontWeight: "bold", flex: "0 0 48%"}}>
                  {props.languageUX === "en" ? "Agency/Clinic" : "หน่วยงาน/คลินิก"}
                  <div
                    id="CardPatientAppointmentUX-div-70">
                    {props.divisionSearch}
                  </div>
                </div>
              </div>
              <div
                id="CardPatientAppointmentUX-div-73"
                style={{display:"flex", justifyContent: "space-between", alignItems:"flex-end", marginBottom: "10px", ...(!props.isShowChair && {display: "none"})}}>
                
                <div
                  id="CardPatientAppointmentUX-div-67"
                  style={{fontWeight: "bold", flex: "0 0 48%"}}>
                  {props.languageUX === "en" ? "Waiting List" : "Waiting List"}
                  <Input
                    icon="filter"
                    id="CardPatientAppointmentUX-Input-71"
                    onChange={props.onChangeWaitingListFilter}
                    value={props.waitingListFilter}>
                  </Input>
                </div>
                <div
                  id="CardPatientAppointmentUX-div-68"
                  style={{fontWeight: "bold", flex: "0 0 48%"}}>
                  
                </div>
              </div>
              <div
                id="CardPatientAppointmentUX-div-7">
                
                <Table
                  className="--rt-tbody-overflow-y-hidden"
                  data={props.appointmentFilterList}
                  getTrProps={props.appointmentRowProps}
                  headers={props.appointmentHeaders || "ชื่อ-สกุล,หน่วยงาน-แพทย์นัดหมาย,วันเวลานัดหมาย,Waiting List"}
                  id="CardPatientAppointmentUX-Table-8"
                  keys={props.appointmentKeys || "patient_name,detail,estimated_at,waiting_list_name"}
                  minRows="10"
                  showPagination={false}
                  style={{height: "calc(100vh - 37rem)", marginBottom: "10px" }}
                  widths={props.appointmentWidths || "^90,^90,^90,^90"}>
                </Table>
              </div>
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-60"
            style={{display: props.mode === "reschedule" ? "block" : "none"}}>
            {props.rescheduleComponent}
          </div>
          <div
            id="CardPatientAppointmentUX-div-63"
            style={{display: props.mode === "reconfirm" ? "block" : "none"}}>
            {props.reconfirmComponent}
          </div>
          <div
            id="CardPatientAppointmentUX-div-61"
            style={{display: props.mode === "waitingList" ? "block" : "none"}}>
            {props.waitingListComponent}
          </div>
        </div>
        <div
          className="patient-appointment-content"
          style={{...props.patientAppointmentContentStyle}}>
          
          <div
            id="CardPatientAppointmentUX-div-13"
            style={{paddingBottom: "2px",marginBottom: "5px", display: props.isOR || props.isPackage || props.isConsult || props.isRehab? "none": "flex", fontWeight: "bold", fontSize: "1.2rem",  borderBottom: "solid #cccccc 1px"   }}>
            
            <Button
              color={props.tab === "detail" ? "blue" : undefined}
              disabled={props.detailDisabled}
              id="CardPatientAppointmentUX-Button-43"
              onClick={(e: any) => props.setTab("detail")}
              size="small">
              {props.languageUX === "en" ? "Appointment details" : "รายละเอียดนัดหมาย"}
            </Button>
            <Button
              color={props.tab === "calendar" ? "blue" : undefined}
              disabled={props.calendarDisabled}
              id="CardPatientAppointmentUX-Button-44"
              onClick={(e: any) => props.setTab("calendar")}
              size="small">
              {props.languageUX === "en" ? "Select inspection date and time" : "เลือกวันเวลาออกตรวจ"}
            </Button>
            <div
              id="CardPatientAppointmentUX-div-146"
              style={{flex:1}}>
              
            </div>
            <Button
              id="CardPatientAppointmentUX-Button-145"
              onClick={props.onClosePatientAppContent}
              size="small"
              style={{display: props.showBtnClosePatientAppContent?"":"none", backgroundColor:"rgb(224, 225, 226,0.5)"}}>
              x ปิดหน้าต่างนี้
            </Button>
          </div>
          <div
            id="CardPatientAppointmentUX-div-32"
            style={{display: props.tab === "calendar" && !props.isOR && !props.isConsult? "block" : "none" }}>
            
            <Form
              id="CardPatientAppointmentUX-Form-129">
              <FormGroup
                id="CardPatientAppointmentUX-FormGroup-130"
                inline={true}
                style={{marginBottom: "5px"}}>
                <FormField
                  id="CardPatientAppointmentUX-FormField-131"
                  inline={true}
                  width={4}>
                  <label
                    id="CardPatientAppointmentUX-label-136">
                    {<>{"แผนก"}<span style={{color:"red"}}>*</span></> }
                  </label>
                  <Dropdown
                    className="inline-label"
                    fluid={true}
                    id="CardPatientAppointmentUX-Dropdown-142"
                    onChange={props.onChangeSelectedDivision}
                    options={props.allDivisionsOptions}
                    search={true}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.selectedDivision}>
                  </Dropdown>
                </FormField>
                <FormField
                  id="CardPatientAppointmentUX-FormField-132"
                  inline={true}
                  width={5}>
                  <label
                    id="CardPatientAppointmentUX-label-137"
                    style={{minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Specialty" : "ความเชี่ยวชาญ"}
                  </label>
                  <Dropdown
                    className="inline-label"
                    clearable={true}
                    fluid={true}
                    id="CardPatientAppointmentUX-Dropdown-143"
                    onChange={props.changeSpecialty}
                    options={props.specialtyOptions}
                    search={true}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.specialty}>
                  </Dropdown>
                </FormField>
                <FormField
                  id="CardPatientAppointmentUX-FormField-133"
                  inline={true}>
                  <Checkbox
                    checked={props.onlyNewPatient}
                    id="CardPatientAppointmentUX-Checkbox-139"
                    label={props.languageUX === "en" ? "Only for doctors who accept new patients" : "เฉพาะแพทย์ที่รับผู้ป่วยใหม่"}
                    onChange={props.changeOnlyNewPatient}
                    style={{minWidth: "max-content"}}>
                  </Checkbox>
                </FormField>
                <FormField
                  id="CardPatientAppointmentUX-FormField-134"
                  inline={true}
                  style={{display: props.hideFilterDivision ? "none" : ""}}
                  width={4}>
                  <label
                    id="CardPatientAppointmentUX-label-138">
                    {props.languageUX === "en" ? "Clinic" : "คลินิก"}
                  </label>
                  <Dropdown
                    className="inline-label"
                    fluid={true}
                    id="CardPatientAppointmentUX-Dropdown-144"
                    onChange={props.changeDivision}
                    options={props.divisionOptions}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.selectedDivisionId}>
                  </Dropdown>
                </FormField>
                <FormField
                  id="CardPatientAppointmentUX-FormField-135"
                  inline={true}
                  width={4}>
                  <div
                    id="CardPatientAppointmentUX-div-140"
                    style={{width: "100%"}}>
                    {props.providerSelector}
                  </div>
                </FormField>
              </FormGroup>
            </Form>
            <div
              id="CardPatientAppointmentUX-div-49"
              style={{height: "85vh"}}>
              
              <Calendar
                endAccessor="end"
                eventPropGetter={props.eventPropGetter}
                events={props.blockList || []}
                formats={props.formats}
                id="CardPatientAppointmentUX-Calendar-48"
                localizer={props.localizer}
                max={props.maxTime}
                min={props.minTime}
                onRangeChange={props.onRangeChange}
                onSelectEvent={props.onSelectEvent}
                startAccessor="start"
                style={{width: "100%", height: "100%", display: "none"}}
                tooltipAccessor="tooltip"
                views={["day", "week", "month"]}>
              </Calendar>
              <div
                style={{width: "100%", height: "100%", }}>
                {props.calendar}
              </div>
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-6"
            style={{ display: props.tab === "detail" && !props.isOR && !props.isPackage  ? "block": "none", height: "95vh" }}>
            {}
            <div
              id="CardPatientAppointmentUX-div-53"
              style={{display: props.selectedAppointment ? "none" : "block" }}>
              {props.languageUX === "en" ? "Please select the patient appointment you wish to make." : "กรุณาเลือกนัดหมายคนไข้ที่ต้องการทำรายการ"}
            </div>
            <div
              id="CardPatientAppointmentUX-div-54"
              style={{display: props.selectedAppointment ? "block" : "none" }}>
              {props.appointmentDetail}
            </div>
          </div>
          <div
            className="patient-appointment-tabs"
            id="CardPatientAppointmentUX-div-84"
            style={{paddingBottom: "2px",marginBottom: "5px", display: props.isOR && !props.isPackage ? "flex": "none", fontWeight: "bold", fontSize: "1.2rem",  borderBottom: "solid #cccccc 1px" }}>
            
            <Button
              color={props.tab === "or_request" ? "blue" : undefined}
              disabled={props.detailDisabled}
              id="CardPatientAppointmentUX-Button-87"
              onClick={(e: any) => props.setTab("or_request")}
              size="small">
              {props.languageUX === "en" ? "OR Request" : "OR Request"}
            </Button>
            <Button
              color={props.tab === "selectdatetimeoperation" ? "blue" : undefined}
              disabled={props.detailDisabled || props.disabledSelectDateTime}
              id="CardPatientAppointmentUX-Button-88"
              onClick={(e: any) => props.setTab("selectdatetimeoperation")}
              size="small">
              {props.languageUX === "en" ? "Select surgery date and time" : "เลือกวันเวลา ผ่าตัด"}
            </Button>
            <Button
              color={props.tab === "otherorderappointment" ? "blue" : undefined}
              disabled={props.detailDisabled || props.disabledOtherOrder}
              id="CardPatientAppointmentUX-Button-89"
              onClick={(e: any) => props.setTab("otherorderappointment")}
              size="small"
              style={{ ...(props.hideOtherOrderAppointment && { display: "none" }) }}>
              {props.languageUX === "en" ? "Doctor's orders for surgery" : "คำสั่งแพทย์ สำหรับผ่าตัด"}
            </Button>
            <div
              id="CardPatientAppointmentUX-div-96">
              {props.ORRequestMessage}
            </div>
            <div
              id="CardPatientAppointmentUX-div-117"
              style={{ flex: "1",  display: "flex", alignItems: "center", justifyContent: "flex-end", fontSize: "12px", ...( !props.isPrinterLanguage && { display: "none" } ) }}>
              
              <label
                id="CardPatientAppointmentUX-label-119"
                style={{ marginRight: "10px" }}>
                {props.languageUX === "en" ? "language" : "ภาษา"}
              </label>
              <Dropdown
                id="CardPatientAppointmentUX-Dropdown-118"
                onChange={props.onChangePrinterLanguage}
                options={props.printerLanguageOptions}
                selection={true}
                style={{ width: "10px" }}
                value={props.printerLanguage}>
              </Dropdown>
            </div>
            <div
              id="CardPatientAppointmentUX-div-97"
              style={{ display: "flex", justifyContent: "flex-end", padding: "0px 5px", ...( !props.isPrinterLanguage && { flex: "1" })}}>
              {props.orPrintAppointmentButton}
            </div>
          </div>
          <div
            className="patient-appointment-tabs"
            id="CardPatientAppointmentUX-div-98"
            style={{marginBottom: "5px", display: props.isPackage? "flex": "none", fontWeight: "bold", fontSize: "1.2rem",  borderBottom: "solid #cccccc 1px" }}>
            
            <Button
              color={props.tab === "selectpackage" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-99"
              onClick={(e: any) => props.setTab("selectpackage")}
              size="small">
              {props.languageUX === "en" ? "Selected Package" : "Package ที่เลือก"}
            </Button>
            <Button
              color={props.tab === "selectdatetimepackage" ? "blue" : undefined}
              disabled={props.disabledSelectDateTimePackage || false}
              id="CardPatientAppointmentUX-Button-100"
              onClick={(e: any) => props.setTab("selectdatetimepackage")}
              size="small">
              {props.languageUX === "en" ? "Select appointment date and time" : "เลือกวันเวลานัดหมาย"}
            </Button>
          </div>
          <div
            id="CardPatientAppointmentUX-div-85"
            style={{display: props.tab === "selectdatetimeoperation" && props.isOR ? "block" : "none" }}>
            
            <div
              id="CardPatientAppointmentUX-div-91"
              style={{display: props.selectedAppointment ? "block" : "none" }}>
              {props.selectdatetimeopertionCard}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-86"
            style={{ display: props.tab === "or_request" && props.isOR  ? "block": "none", height: "95vh" }}>
            {}
            <div
              id="CardPatientAppointmentUX-div-93"
              style={{display: props.selectedAppointment ? "none" : "block" }}>
              {props.languageUX === "en" ? "Please select the patient appointment you wish to make." : "กรุณาเลือกนัดหมายคนไข้ที่ต้องการทำรายการ"}
            </div>
            <div
              id="CardPatientAppointmentUX-div-94"
              style={{display: props.selectedAppointment ? "block" : "none" }}>
              {props.CardORRequest}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-90"
            style={{display: props.tab === "otherorderappointment" && props.isOR ? "block" : "none" }}>
            
            <div
              id="CardPatientAppointmentUX-div-95"
              style={{display: props.selectedAppointment ? "block" : "none" }}>
              {props.otherOrderAppointmentCard}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-101"
            style={{ display: props.tab === "selectpackage" && props.isPackage? "block": "none", height: "95vh" }}>
            
            <div
              id="CardPatientAppointmentUX-div-102">
              {props.selectpackageCard}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-103"
            style={{ display: props.tab === "selectdatetimepackage" && props.isPackage? "block": "none", height: "95vh" }}>
            
            <div
              id="CardPatientAppointmentUX-div-104">
              {props.selectdatetimepackageCard}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-105"
            style={{marginBottom: "5px", display: props.isConsult && !props.isPackage ? "flex": "none", fontWeight: "bold", fontSize: "1.2rem",  borderBottom: "solid #cccccc 1px"   }}>
            
            <Button
              color={props.tab === "consultDetail" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-106"
              onClick={(e: any) => props.setTab("consultDetail")}
              size="small">
              {props.languageUX === "en" ? "Consultation details" : "รายละเอียดการ Consult"}
            </Button>
            <Button
              color={props.tab === "consultDateTime" ? "blue" : undefined}
              disabled={!props.consultDetail?.note || !props.consultDetail?.consultDivision}
              id="CardPatientAppointmentUX-Button-107"
              onClick={(e: any) => props.setTab("consultDateTime")}
              size="small">
              {props.languageUX === "en" ? "Select appointment date and time" : "เลือกวันเวลานัดหมาย"}
            </Button>
          </div>
          <div
            id="CardPatientAppointmentUX-div-108"
            style={{ display: props.tab === "consultDetail" && props.isConsult? "block": "none", height: "70vh" }}>
            
            <div
              id="CardPatientAppointmentUX-div-110">
              {props.selectConsultDetail}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-109"
            style={{ display: props.tab === "consultDateTime" && props.isConsult? "block": "none", height: "85vh" }}>
            
            <div
              id="CardPatientAppointmentUX-div-111">
              {props.selectConsultDateTime}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-122"
            style={{marginBottom: "5px", display: props.isRehab? "flex": "none", fontWeight: "bold", fontSize: "1.2rem",  borderBottom: "solid #cccccc 1px" }}>
            
            <Button
              color={props.tab === "selectrehab" ? "blue" : undefined}
              id="CardPatientAppointmentUX-Button-124"
              onClick={(e: any) => props.setTab("selectrehab")}
              size="small">
              {props.languageUX === "en" ? "Treatment Plan" : "แผนการรักษา"}
            </Button>
            <Button
              color={props.tab === "selectdatetimerehab" ? "blue" : undefined}
              disabled={props.disabledSelectDateTimeRehab || false}
              id="CardPatientAppointmentUX-Button-125"
              onClick={(e: any) => props.setTab("selectdatetimerehab")}
              size="small">
              {props.languageUX === "en" ? "Appointment date/time" : "วัน/เวลานัดหมาย"}
            </Button>
          </div>
          <div
            id="CardPatientAppointmentUX-div-123"
            style={{ display: props.tab === "selectrehab" && props.isRehab? "block": "none", height: "" }}>
            
            <div
              id="CardPatientAppointmentUX-div-126">
              {props.selectrehabCard}
            </div>
          </div>
          <div
            id="CardPatientAppointmentUX-div-127"
            style={{ display: props.tab === "selectdatetimerehab" && props.isRehab? "block": "none", height: "" }}>
            
            <div
              id="CardPatientAppointmentUX-div-128">
              {props.selectdatetimerehabCard}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardPatientAppointmentUX

export const screenPropsDefault = {"appointmentDetail":"ux ดูใน CardAppointmentDetailUX","calendar":true,"disable":false,"hide":false,"label":"click","language":"TH","mode":"search","providerSelector":"[Component สำหรับเลือก Provider]","reschedule":"ux ดูใน CardRescheduleUX","selectedAppointment":{},"tab":"calendar","waitingList":"ux ดูใน CardWaitingListUX"}

/* Date Time : Mon Nov 24 2025 17:00:20 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"95dvh\", display: \"flex\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "brown"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-1"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onPatientSearch"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", gap: \"5px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-4"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 5,
      "name": "Table",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.patientList"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.patientRowProps"
        },
        "headers": {
          "type": "value",
          "value": "HN,ชื่อ-สกุล,Citizen ID/Passport No.,เบอร์โทรติดต่อ"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Table-5"
        },
        "keys": {
          "type": "value",
          "value": "hn,full_name, citizen_passport, present_mobile_no"
        },
        "minRows": {
          "type": "value",
          "value": "4"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"175px\", marginBottom: \"10px\" }"
        },
        "widths": {
          "type": "value",
          "value": "^80,^80,^120,^90"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"detail\" && !props.isOR && !props.isPackage  ? \"block\": \"none\", height: \"95vh\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-7"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.appointmentFilterList"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.appointmentRowProps"
        },
        "headers": {
          "type": "code",
          "value": "props.appointmentHeaders || \"ชื่อ-สกุล,หน่วยงาน-แพทย์นัดหมาย,วันเวลานัดหมาย,Waiting List\""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Table-8"
        },
        "keys": {
          "type": "code",
          "value": "props.appointmentKeys || \"patient_name,detail,estimated_at,waiting_list_name\""
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(100vh - 37rem)\", marginBottom: \"10px\" }"
        },
        "widths": {
          "type": "code",
          "value": "props.appointmentWidths || \"^90,^90,^90,^90\""
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "คนไข้จากคำค้นหา",
          "valueEN": "Patients from search terms"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"1.2rem\", margin: \"5px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"1.2rem\", margin: \"12px 0px 5px 0px\", display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\" }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"2px\",marginBottom: \"5px\", display: props.isOR || props.isPackage || props.isConsult || props.isRehab? \"none\": \"flex\", fontWeight: \"bold\", fontSize: \"1.2rem\",  borderBottom: \"solid #cccccc 1px\"   }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "patient-appointment-panel"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\", flex: 1, backgroundColor: \"#d6ecf3\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "นัดหมายก่อนหน้า",
          "valueEN": "Previous appointment"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-19"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideAppointmentTable ? \"none\" : \"block\" }"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "patient-appointment-content"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{...props.patientAppointmentContentStyle}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"calendar\" && !props.isOR && !props.isConsult? \"block\" : \"none\" }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดนัดหมาย",
          "valueEN": "Appointment details"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"detail\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.detailDisabled"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-43"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"detail\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลาออกตรวจ",
          "valueEN": "Select inspection date and time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"calendar\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.calendarDisabled"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-44"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"calendar\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-46"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "react-big-calendar",
      "id": 48,
      "name": "Calendar",
      "parent": 49,
      "props": {
        "endAccessor": {
          "type": "value",
          "value": "end"
        },
        "endAccessors": {
          "type": "value",
          "value": ""
        },
        "eventPropGetter": {
          "type": "code",
          "value": "props.eventPropGetter"
        },
        "events": {
          "type": "code",
          "value": "props.blockList || []"
        },
        "formats": {
          "type": "code",
          "value": "props.formats"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Calendar-48"
        },
        "localizer": {
          "type": "code",
          "value": "props.localizer"
        },
        "max": {
          "type": "code",
          "value": "props.maxTime"
        },
        "min": {
          "type": "code",
          "value": "props.minTime"
        },
        "onRangeChange": {
          "type": "code",
          "value": "props.onRangeChange"
        },
        "onSelectEvent": {
          "type": "code",
          "value": "props.onSelectEvent"
        },
        "startAccessor": {
          "type": "value",
          "value": "start"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", display: \"none\"}"
        },
        "tooltipAccessor": {
          "type": "value",
          "value": "tooltip"
        },
        "views": {
          "type": "code",
          "value": "[\"day\", \"week\", \"month\"]"
        }
      },
      "seq": 48,
      "void": true
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{height: \"85vh\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณาเลือกนัดหมายคนไข้ที่ต้องการทำรายการ",
          "valueEN": "Please select the patient appointment you wish to make."
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedAppointment ? \"none\" : \"block\" }"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.appointmentDetail"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedAppointment ? \"block\" : \"none\" }"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{display: props.mode === \"search\" ? \"block\" : \"none\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "patient-appointment-menus"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom:\"5px\", borderBottom: \"solid #cccccc 1px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Button",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "code",
          "value": "props.mode === \"search\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-57"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.setMode(\"search\")"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"1.25em\", paddingLeft: \"1.25rem\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Button",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "เลื่อน (คลินิก)",
          "valueEN": "Postpone (Clinic)"
        },
        "color": {
          "type": "code",
          "value": "props.mode === \"reschedule\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-58"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.setMode(\"reschedule\")"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "props.disabledPostponeBtn ? {display: \"none\"} : {display: \"inline-block\",paddingRight: \"1.25em\", paddingLeft: \"1.25rem\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Button",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "Waiting List",
          "valueEN": "Waiting List"
        },
        "color": {
          "type": "code",
          "value": "props.mode === \"waitingList\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-59"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.setMode(\"waitingList\")"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "props.disabledWaitingListBtn ? {display: \"none\"} : {display: \"inline-block\",paddingRight: \"1.25em\", paddingLeft: \"1.25rem\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rescheduleComponent"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{display: props.mode === \"reschedule\" ? \"block\" : \"none\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.waitingListComponent"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{display: props.mode === \"waitingList\" ? \"block\" : \"none\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Button",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "เลื่อน (ผู้ป่วย)",
          "valueEN": "Postpone (patient)"
        },
        "color": {
          "type": "code",
          "value": "props.mode === \"reconfirm\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-62"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.setMode(\"reconfirm\")"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "props.disabledPostponeBtn ? {display: \"none\"} : {display: \"inline-block\",paddingRight: \"1.25em\", paddingLeft: \"1.25rem\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.reconfirmComponent"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{display: props.mode === \"reconfirm\" ? \"block\" : \"none\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "physician"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", flex: \"0 0 48%\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงาน/คลินิก",
          "valueEN": "Agency/Clinic"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", flex: \"0 0 48%\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "Waiting List",
          "valueEN": "Waiting List"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", flex: \"0 0 48%\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", flex: \"0 0 48%\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearch"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.divisionSearch"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Input",
      "parent": 67,
      "props": {
        "icon": {
          "type": "value",
          "value": "filter"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Input-71"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeWaitingListFilter"
        },
        "value": {
          "type": "code",
          "value": "props.waitingListFilter"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent: \"space-between\", alignItems:\"flex-end\", marginBottom: \"10px\", ...(!props.isShowChair && {display: \"none\"})}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientSearch"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "HN ผู้ป่วย",
          "valueEN": "HN patient"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-81"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Button",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มนัดหมาย",
          "valueEN": "Add appointment"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledCreatePatientAppointment"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-82"
        },
        "onClick": {
          "type": "code",
          "value": "props.createPatientAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display : props.PopupElement ? \"none\": \"\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PopupElement"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-83"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "patient-appointment-tabs"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: \"2px\",marginBottom: \"5px\", display: props.isOR && !props.isPackage ? \"flex\": \"none\", fontWeight: \"bold\", fontSize: \"1.2rem\",  borderBottom: \"solid #cccccc 1px\" }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"selectdatetimeoperation\" && props.isOR ? \"block\" : \"none\" }"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"or_request\" && props.isOR  ? \"block\": \"none\", height: \"95vh\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Button",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "OR Request",
          "valueEN": "OR Request"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"or_request\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.detailDisabled"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-87"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"or_request\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลา ผ่าตัด",
          "valueEN": "Select surgery date and time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"selectdatetimeoperation\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.detailDisabled || props.disabledSelectDateTime"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-88"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"selectdatetimeoperation\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Button",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "คำสั่งแพทย์ สำหรับผ่าตัด",
          "valueEN": "Doctor's orders for surgery"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"otherorderappointment\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.detailDisabled || props.disabledOtherOrder"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-89"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"otherorderappointment\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.hideOtherOrderAppointment && { display: \"none\" }) }"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{display: props.tab === \"otherorderappointment\" && props.isOR ? \"block\" : \"none\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectdatetimeopertionCard"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedAppointment ? \"block\" : \"none\" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณาเลือกนัดหมายคนไข้ที่ต้องการทำรายการ",
          "valueEN": "Please select the patient appointment you wish to make."
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedAppointment ? \"none\" : \"block\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CardORRequest"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedAppointment ? \"block\" : \"none\" }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props.otherOrderAppointmentCard"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedAppointment ? \"block\" : \"none\" }"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ORRequestMessage"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orPrintAppointmentButton"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", padding: \"0px 5px\", ...( !props.isPrinterLanguage && { flex: \"1\" })}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "patient-appointment-tabs"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"5px\", display: props.isPackage? \"flex\": \"none\", fontWeight: \"bold\", fontSize: \"1.2rem\",  borderBottom: \"solid #cccccc 1px\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Button",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "Package ที่เลือก",
          "valueEN": "Selected Package"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"selectpackage\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-99"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"selectpackage\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Button",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลานัดหมาย",
          "valueEN": "Select appointment date and time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"selectdatetimepackage\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSelectDateTimePackage || false"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-100"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"selectdatetimepackage\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"selectpackage\" && props.isPackage? \"block\": \"none\", height: \"95vh\" }"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectpackageCard"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-102"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"selectdatetimepackage\" && props.isPackage? \"block\": \"none\", height: \"95vh\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectdatetimepackageCard"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-104"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"5px\", display: props.isConsult && !props.isPackage ? \"flex\": \"none\", fontWeight: \"bold\", fontSize: \"1.2rem\",  borderBottom: \"solid #cccccc 1px\"   }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Button",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการ Consult",
          "valueEN": "Consultation details"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"consultDetail\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-106"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"consultDetail\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Button",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลานัดหมาย",
          "valueEN": "Select appointment date and time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"consultDateTime\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.consultDetail?.note || !props.consultDetail?.consultDivision"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-107"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"consultDateTime\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"consultDetail\" && props.isConsult? \"block\": \"none\", height: \"70vh\" }"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"consultDateTime\" && props.isConsult? \"block\": \"none\", height: \"85vh\" }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectConsultDetail"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-110"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 109,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectConsultDateTime"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-111"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{ flex: \"1\",  display: \"flex\", alignItems: \"center\", justifyContent: \"flex-end\", fontSize: \"12px\", ...( !props.isPrinterLanguage && { display: \"none\" } ) }"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "Dropdown",
      "parent": 117,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Dropdown-118"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePrinterLanguage"
        },
        "options": {
          "type": "code",
          "value": "props.printerLanguageOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"10px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.printerLanguage"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "label",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาษา",
          "valueEN": "language"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-label-119"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"5px\", display: props.isRehab? \"flex\": \"none\", fontWeight: \"bold\", fontSize: \"1.2rem\",  borderBottom: \"solid #cccccc 1px\" }"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"selectrehab\" && props.isRehab? \"block\": \"none\", height: \"\" }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "Button",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนการรักษา",
          "valueEN": "Treatment Plan"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"selectrehab\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-124"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"selectrehab\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Button",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "วัน/เวลานัดหมาย",
          "valueEN": "Appointment date/time"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"selectdatetimerehab\" ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSelectDateTimeRehab || false"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-125"
        },
        "onClick": {
          "type": "code",
          "value": "(e: any) => props.setTab(\"selectdatetimerehab\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectrehabCard"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-126"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.tab === \"selectdatetimerehab\" && props.isRehab? \"block\": \"none\", height: \"\" }"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectdatetimerehabCard"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-128"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Form",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Form-129"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormGroup",
      "parent": 129,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-FormGroup-130"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"5px\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-FormField-131"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-FormField-132"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-FormField-133"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-FormField-134"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideFilterDivision ? \"none\" : \"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-FormField-135"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "label",
      "parent": 131,
      "props": {
        "children": {
          "type": "code",
          "value": "<>{\"แผนก\"}<span style={{color:\"red\"}}>*</span></> "
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-label-136"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "label",
      "parent": 132,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเชี่ยวชาญ",
          "valueEN": "Specialty"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-label-137"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "label",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "คลินิก",
          "valueEN": "Clinic"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-label-138"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "Checkbox",
      "parent": 133,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.onlyNewPatient"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Checkbox-139"
        },
        "label": {
          "type": "value",
          "value": "เฉพาะแพทย์ที่รับผู้ป่วยใหม่",
          "valueEN": "Only for doctors who accept new patients"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeOnlyNewPatient"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 135,
      "props": {
        "children": {
          "type": "code",
          "value": "props.providerSelector"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "Dropdown",
      "parent": 131,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Dropdown-142"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSelectedDivision"
        },
        "options": {
          "type": "code",
          "value": "props.allDivisionsOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivision"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Dropdown",
      "parent": 132,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Dropdown-143"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSpecialty"
        },
        "options": {
          "type": "code",
          "value": "props.specialtyOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.specialty"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Dropdown",
      "parent": 134,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Dropdown-144"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionId"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Button",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "x ปิดหน้าต่างนี้"
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-Button-145"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClosePatientAppContent"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showBtnClosePatientAppContent?\"\":\"none\", backgroundColor:\"rgb(224, 225, 226,0.5)\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPatientAppointmentUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calendar"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\", }"
        }
      },
      "seq": 147,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 95,
  "isMounted": false,
  "memo": false,
  "name": "CardPatientAppointmentUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "appointmentDetail": "ux ดูใน CardAppointmentDetailUX",
    "calendar": true,
    "disable": false,
    "hide": false,
    "label": "click",
    "language": "TH",
    "mode": "search",
    "providerSelector": "[Component สำหรับเลือก Provider]",
    "reschedule": "ux ดูใน CardRescheduleUX",
    "selectedAppointment": {
    },
    "tab": "calendar",
    "waitingList": "ux ดูใน CardWaitingListUX"
  },
  "width": 90
}

*********************************************************************************** */
